import { render, staticRenderFns } from "./svgslide20.vue?vue&type=template&id=4447974e&scoped=true&"
var script = {}
import style0 from "./svgslide20.vue?vue&type=style&index=0&id=4447974e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4447974e",
  null
  
)

export default component.exports